// Глобальные @keyframes кита (§0b «плавные переходы/анимации») + минимальный document-reset.
// Инжектируются один раз в <head>. Чисто косметика/раскладка — на нет-DOM (SSR) — no-op. На вызове
// ensureGlobalStyles() в коде потребителя (или автоматически — компоненты, которым нужны кейфреймы,
// зовут сами; ThemeProvider зовёт на маунте).
const STYLE_ID = 'tc-ds-global-keyframes';
const KEYFRAMES = `
@keyframes tc-ds-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
@keyframes tc-ds-fade-in{from{opacity:0}to{opacity:1}}
@keyframes tc-ds-sheet-up{from{transform:translateY(100%)}to{transform:translateY(0)}}
@keyframes tc-ds-push-in{from{transform:translateX(16%);opacity:.6}to{transform:translateX(0);opacity:1}}
@keyframes tc-ds-pulse{0%,100%{opacity:1}50%{opacity:.35}}
@keyframes tc-ds-typing{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-3px);opacity:1}}
@keyframes tc-ds-indeterminate{0%{transform:translateX(-100%)}100%{transform:translateX(250%)}}
@keyframes tc-ds-kb-reenter{from{transform:translateY(-110%)}to{transform:translateY(0)}}
html.tc-kb-settle [data-chat-header]{animation:tc-ds-kb-reenter .8s cubic-bezier(.16,1,.3,1) 60ms backwards;will-change:transform}
`;
// Document-reset: тема рисует сплошной фон на своём корне (data-ds-root, height:100%), но без 100%-й
// цепочки высоты html→body→#root этот корень схлопывается до высоты контента — снизу/по краям пробивался
// белый фон страницы, а на mobile StackPane (position:absolute;inset:0;overflow:hidden) в 0-высотном
// контейнере давал полностью белый экран и неинтерактивный UI. Ставим всю цепочку в 100% и снимаем
// браузерный body{margin:8px}. (#root — конвенция точки монтирования SPA; на других контейнерах безвреден.)
// + запрет горизонтального «плавания» экрана на mobile (только вертикальный скролл): overflow-x:hidden
// снимает случайный горизонтальный скролл, overscroll-behavior:none — резиновый bounce вьюпорта.
// + `-webkit-text-size-adjust:100%` — iOS Safari/standalone авто-РАЗДУВАЕТ шрифты «главного контента»,
//   когда считает раскладку не-мобильной: rem-шрифты вырастали ~в 3× → строки списка/шапка вылезали за
//   правый край (бейдж/время/гамбургер обрезаны). Chromium этого механизма НЕ имеет (баг там не
//   воспроизводится). Фиксируем 100% — шрифты рендерятся ровно в заданном размере, раскладка = desktop.
// + `--safe-*` = env(safe-area-inset-*) как CSS-vars (padding на #root ниже): контент не заезжает под
//   системную строку/челку iPhone в standalone (viewport-fit=cover в index.html открывает эти зоны).
//   Вынос в переменные делает отступ проверяемым (в тестах/браузере можно переопределить --safe-top).
// + на touch-устройствах (pointer:coarse) отключаем нативное выделение текста и iOS-callout НА ВСЁМ UI
//   (не только на пузыре): долгое нажатие по сообщению/пункту меню больше не выделяет текст самим
//   браузером и не поднимает браузерное контекст-меню поверх нашего — открывается только НАШЕ меню
//   (long-press в MessageBubble). Ввод (input/textarea/[data-allow-select]) — выделяемы (правка текста).
// + поля ввода на touch = font-size:16px: iOS при фокусе на input со шрифтом <16px АВТО-ЗУМИТ страницу
//   («содержимое растягивается при наборе, приходится сжимать»); 16px это гасит без отключения зума.
// + экранная клавиатура (iOS): модель «УЕХАЛИ ВМЕСТЕ → ШАПКА ПЛАВНО ВОЗВРАЩАЕТСЯ СВЕРХУ» (решение
//   пользователя после 8 итераций борьбы с композитором). Эмпирика покадрового разбора 7 видео iPhone
//   (2026-07-04, ?vvdebug): iOS при фокусе в поле ВСЕГДА даёт транзиент — либо форс-скролл документа на
//   высоту клавиатуры (если поле под ней), либо композиторный переякорь поверхности (ездят даже
//   position:fixed-слои при scrollY=offsetTop=0) — JS слеп, CSS бессилен, борьба (pin в транзиенте)
//   даёт мигание. Поэтому НЕ БОРЕМСЯ: фаза 1 — выезд клавиатуры, iOS нативно уводит ВСЁ содержимое
//   (вместе с шапкой) вверх — плавно, как обычный скролл; фаза 2 — по установке клавиатуры (~350мс)
//   ensureViewportHeight ставит финальную раскладку ВОКРУГ фактического iOS-скролла, НЕ сбрасывая его
//   (scrollTo(0,0) в коррекции = полный репейнт страницы в один кадр — «моргала вся страница»):
//   --tc-shift = window.scrollY (сколько iOS уехал), html растёт на shift (скролл становится легальным
//   в диапазоне — iOS его не переклампит), контент #root сдвигается вниз тем же shift через padding-top
//   → сообщения/композер остаются в ТЕХ ЖЕ координатах страницы (перерисовки нет), composер прижат к
//   клавиатуре padding-bottom = max(safe-bottom, --tc-kb), kb = clientHeight − vv.height. Меняется
//   только верхняя полоса — её накрывает шапка [data-chat-header], плавно ВЫЕЗЖАЮЩАЯ СВЕРХУ по классу
//   html.tc-kb-settle (tc-ds-kb-reenter). Скрытие клавиатуры: shift/kb → 0, scrollTo(0,0), мгновенно.
//   interactive-widget в Safari НЕ поддержан — kb меряем сами; window.innerHeight в транзиенте скачет
//   (667→324→667) — мерить ТОЛЬКО по documentElement.clientHeight − vv.height. Пин держит фактический
//   scrollY = shift ВНЕ транзиента выезда (в транзиенте не боремся). Chromium/desktop: kb=shift=0.
const RESET = `
html{-webkit-text-size-adjust:100%;text-size-adjust:100%}
body{margin:0}
:root{--tc-kb:0px;--tc-shift:0px}
html{height:calc(100% + var(--tc-shift))}
body{height:100%}
html,body{overflow:hidden;overscroll-behavior:none;background:var(--color-bg)}
:root{--safe-top:env(safe-area-inset-top);--safe-right:env(safe-area-inset-right);--safe-bottom:env(safe-area-inset-bottom);--safe-left:env(safe-area-inset-left)}
#root{position:relative;width:100%;height:100%;box-sizing:border-box;padding:calc(var(--safe-top) + var(--tc-shift)) var(--safe-right) max(var(--safe-bottom),var(--tc-kb)) var(--safe-left)}
@media (pointer:coarse){
body{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}
input,textarea,[contenteditable="true"],[data-allow-select],[data-allow-select] *{-webkit-user-select:text;user-select:text;-webkit-touch-callout:default}
input,textarea,select{font-size:16px}
}
`;
/** Однократно вставляет @keyframes + document-reset в документ (идемпотентно, SSR-safe). */
export function ensureGlobalStyles() {
    if (typeof document === 'undefined')
        return;
    if (document.getElementById(STYLE_ID))
        return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = RESET + KEYFRAMES;
    document.head.appendChild(style);
}
const VIEWPORT_FLAG = '__tcViewportHeightBound';
/**
 * Оркестрирует модель «уехали вместе → шапка плавно возвращается сверху» (см. RESET). Выезд клавиатуры:
 * НЕ вмешиваемся (~350мс) — iOS нативно уводит содержимое вверх; затем разом финальная раскладка
 * (`--tc-kb` = clientHeight − visualViewport.height в padding-bottom #root + scrollTo 0,0) и класс
 * `tc-kb-settle` на <html> — шапка [data-chat-header] анимированно выезжает сверху. Скрытие клавиатуры —
 * мгновенно (в эту сторону iOS не дёргает). Пин страхует от залипшего форс-скролла вне транзиента.
 * Идемпотентна (флаг на window), SSR-safe. Нет visualViewport → kb всегда 0 (прежнее поведение).
 */
export function ensureViewportHeight() {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    const w = window;
    if (w[VIEWPORT_FLAG] === true)
        return;
    w[VIEWPORT_FLAG] = true;
    const root = document.documentElement;
    const vv = window.visualViewport;
    // kb = слой клавиатуры = clientHeight (layout-viewport, стабилен) − vv.height (визуальный, сжимается).
    // НЕ по window.innerHeight — он в транзиенте скачет (667→324→667). Порог 60px отсекает дрожь тулбара
    // Safari при перетаскиваниях (реальная клавиатура ≥200).
    const measureKb = () => {
        if (!vv)
            return 0;
        const kb = Math.round(root.clientHeight - vv.height);
        return kb >= 60 ? kb : 0;
    };
    let appliedKb = 0;
    let appliedShift = 0; // фактический iOS-скролл, вокруг которого построена текущая раскладка
    let transient = false; // фаза выезда клавиатуры: iOS скроллит/панорамирует сам — не боремся
    let settleTimer = 0;
    const apply = (kb, animateHeader) => {
        transient = false;
        appliedKb = kb;
        // Сколько iOS реально уехал — строим раскладку ВОКРУГ этого, скролл НЕ сбрасываем (сброс = полный
        // репейнт страницы в один кадр = «моргает вся страница»). Контент остаётся в тех же координатах.
        const shift = kb > 0 ? Math.max(0, Math.round(window.scrollY)) : 0;
        appliedShift = shift;
        // Ленты, прижатые к низу, замеряем ДО перестройки и доякориваем СИНХРОННО в этом же тике (штатный
        // ResizeObserver-якорь MessageList опаздывает на 1-2 кадра → прыжок строк). Порог 80px = atBottom
        // самого MessageList; листающему историю ленту не трогаем.
        const anchored = [];
        for (const el of Array.from(document.querySelectorAll('[data-message-list]'))) {
            if (el.scrollHeight - el.scrollTop - el.clientHeight < 80)
                anchored.push(el);
        }
        root.style.setProperty('--tc-kb', `${kb}px`);
        root.style.setProperty('--tc-shift', `${shift}px`);
        if (kb === 0 && (window.scrollX !== 0 || window.scrollY !== 0))
            window.scrollTo(0, 0);
        for (const el of anchored)
            el.scrollTop = el.scrollHeight;
        if (animateHeader) {
            // Анимация стартует с 60мс задержкой + backwards-фиксацией (from-состояние держится в задержке):
            // браузер успевает дорисовать перестройку раскладки ДО первого кадра слайда — без этого первые
            // кадры выпадали и шапка появлялась «рывком».
            root.classList.add('tc-kb-settle');
            window.setTimeout(() => root.classList.remove('tc-kb-settle'), 1000);
        }
    };
    // Страховка ВНЕ транзиента: держим фактический скролл на applied-значении (при открытой клавиатуре
    // это shift, вокруг которого построена раскладка; без клавиатуры — 0). В транзиенте отключена, чтобы
    // не бороться с нативной анимацией iOS — борьба = мигание.
    const pin = () => {
        if (transient)
            return;
        if (window.scrollX !== 0 || Math.round(window.scrollY) !== appliedShift) {
            window.scrollTo(0, appliedShift);
        }
    };
    const onViewportChange = () => {
        const kb = measureKb();
        if (kb === appliedKb)
            return;
        window.clearTimeout(settleTimer);
        if (kb > 0 && appliedKb === 0) {
            // Клавиатура ВЫЕЗЖАЕТ: даём iOS увезти всё (вместе с шапкой) нативно; по установке (~350мс от
            // события vv) — финальная раскладка + шапка плавно выезжает сверху.
            transient = true;
            settleTimer = window.setTimeout(() => apply(measureKb(), true), 350);
        }
        else if (kb === 0) {
            // Клавиатура ПРЯЧЕТСЯ: раскладку возвращаем сразу.
            apply(0, false);
        }
        else {
            // Высота клавиатуры изменилась при открытой (язык/эмодзи-панель) или дрожь при драге — дебаунс
            // без анимации шапки.
            settleTimer = window.setTimeout(() => apply(measureKb(), false), 150);
        }
    };
    apply(measureKb(), false);
    window.addEventListener('scroll', pin, { passive: true });
    vv?.addEventListener('resize', onViewportChange);
    window.addEventListener('resize', onViewportChange);
    window.addEventListener('orientationchange', onViewportChange);
    // Перетягивание страницы при ОТКРЫТОЙ клавиатуре: документ теперь имеет легальный диапазон прокрутки
    // (= shift, вокруг которого построена раскладка), и пан пальцем по нескроллируемым зонам (шапка,
    // композер) таскал всю страницу; пин возвращал её лишь по отпусканию. Направленный гейт: touchmove
    // разрешён, только если между target и body есть скроллер, способный прокрутиться в направлении
    // жеста (лента сообщений, списки) — тогда скроллит ОН; на его границе и на нескроллируемых зонах —
    // preventDefault (страница неподвижна, прокрутка не «выливается» в документ). При закрытой
    // клавиатуре гейт спит (диапазона нет, нативное поведение нетронуто).
    let touchY = 0;
    document.addEventListener('touchstart', (e) => {
        touchY = e.touches[0]?.clientY ?? 0;
    }, { passive: true });
    document.addEventListener('touchmove', (e) => {
        if (appliedKb === 0 || e.touches.length !== 1)
            return;
        const y = e.touches[0]?.clientY ?? 0;
        const dy = y - touchY;
        touchY = y;
        let el = e.target instanceof Element ? e.target : null;
        while (el !== null && el !== document.body) {
            const s = el;
            const st = window.getComputedStyle(s);
            if ((st.overflowY === 'auto' || st.overflowY === 'scroll') && s.scrollHeight > s.clientHeight + 1) {
                if (dy < 0 && s.scrollTop + s.clientHeight < s.scrollHeight - 1)
                    return;
                if (dy > 0 && s.scrollTop > 0)
                    return;
            }
            el = el.parentElement;
        }
        e.preventDefault();
    }, { passive: false });
    // Диагностика ?vvdebug — оверлей визуального вьюпорта, живой во время анимации клавиатуры (для
    // телеметрии с реального iPhone). Без флага mkVvDebug() → undefined, ничего не вешаем.
    const dbg = mkVvDebug();
    if (dbg && vv) {
        let raf = 0;
        let until = 0;
        const tick = () => {
            dbg(vv);
            if (performance.now() < until)
                raf = requestAnimationFrame(tick);
            else
                raf = 0;
        };
        const arm = () => {
            until = performance.now() + 900;
            dbg(vv);
            if (raf === 0)
                raf = requestAnimationFrame(tick);
        };
        arm();
        vv.addEventListener('resize', arm);
        vv.addEventListener('scroll', arm);
        document.addEventListener('focusin', arm);
        document.addEventListener('focusout', arm);
    }
}
/**
 * Диагностический оверлей визуального вьюпорта (включается `?vvdebug=1` в URL). Показывает live
 * offsetTop/height/innerHeight/scrollY + пиковый offsetTop за 2с — чтобы на реальном iPhone увидеть,
 * как метрики ведут себя во время анимации клавиатуры (воспроизвести на Chromium нельзя). Возвращает
 * функцию-сэмплер (или undefined, если флаг не задан) — вызывается из горячего цикла ensureViewportHeight.
 */
function mkVvDebug() {
    if (typeof location === 'undefined' || !/[?&]vvdebug=1/.test(location.search))
        return undefined;
    const el = document.createElement('div');
    el.setAttribute('data-vv-debug', '');
    el.style.cssText =
        'position:fixed;z-index:2147483647;left:0;top:0;padding:4px 8px;font:12px/1.35 monospace;' +
            'background:rgba(0,0,0,.82);color:#0f0;white-space:pre;pointer-events:none;border-bottom-right-radius:6px';
    document.body.appendChild(el);
    let peak = 0;
    let peakAt = 0;
    return (vv) => {
        const now = performance.now();
        const ot = Math.round(vv.offsetTop);
        if (ot >= peak || now - peakAt > 2000) {
            peak = ot;
            peakAt = now;
        }
        el.textContent =
            `offsetTop ${ot}  peak2s ${peak}\n` +
                `vv.h ${Math.round(vv.height)}  inner ${window.innerHeight}\n` +
                `scrollY ${Math.round(window.scrollY)}  pageTop ${Math.round(vv.pageTop)}`;
    };
}
/** Сырой текст keyframes — на случай SSR-инлайна потребителем. */
export const GLOBAL_KEYFRAMES_CSS = KEYFRAMES;
/** Сырой текст document-reset — на случай SSR-инлайна потребителем. */
export const GLOBAL_RESET_CSS = RESET;
//# sourceMappingURL=styles.js.map